import { motion } from 'framer-motion';
import { useState } from 'react';
import { Link } from 'react-scroll';

const Navbar = () => {
  const [activeTab, setActiveTab] = useState('Home');

  const menuItems = [
    { id: 1, title: 'Home' },
    { id: 2, title: 'Products' },
    { id: 3, title: 'Services' },
    { id: 5, title: 'Contact' },
  ];

  return (
    <motion.header
      className="fixed top-0 left-0 w-full hidden md:flex items-center justify-center h-16 z-30"
      style={{
        backdropFilter: 'blur(16px)',
        WebkitBackdropFilter: 'blur(16px)',
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        border: '1px solid rgba(0, 0, 0, 0.05)',
        boxShadow: '0 4px 30px rgba(0, 0, 0, 0.08)',
      }}
    >
      <nav className="flex items-center">
        <ul className="flex items-center gap-1">
          {menuItems.map(({ id, title }) => (
            <li key={id}>
              <Link
                to={title}
                smooth={true}
                duration={450}
                offset={-64}
                spy={true}
                onSetActive={() => setActiveTab(title)}
              >
                <motion.div
                  className={`relative px-4 py-1.5 rounded-xl cursor-pointer font-primary text-sm transition-colors duration-200 ${
                    activeTab === title
                      ? 'text-white'
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  {activeTab === title && (
                    <motion.div
                      layoutId="activeTab"
                      className="absolute inset-0 bg-[#0D5192] rounded-xl"
                      style={{ zIndex: -1 }}
                      transition={{
                        type: 'tween',
                        duration: 0.25,
                        ease: [0.25, 0.1, 0.25, 1],
                      }}
                    />
                  )}
                  {title}
                </motion.div>
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </motion.header>
  );
};

export default Navbar;
